import { ReactNode } from "react";

export default function InputErrorMessage(props: {
  value: ReactNode;
  className?: string;
  id?: string;
}) {
  return (
    <small
      id={props.id}
      className={`text-danger mt-1 fw-semibold${
        props.className ? ` ${props.className}` : ""
      }`}
    >
      {props.value}
    </small>
  );
}
